// frontend/src/lib/zoteroImportMemory.ts
export interface ZoteroImportMemory {
  collectionKeys: string[];
  conceptId: string | null;
  role: "trawled" | "foundational";
}
const KEY = "paperchase-zotero-import-last-v1";

export function loadImportMemory(): ZoteroImportMemory | null {
  try { const raw = localStorage.getItem(KEY); return raw ? JSON.parse(raw) : null; }
  catch { return null; }
}
export function saveImportMemory(m: ZoteroImportMemory): void {
  try { localStorage.setItem(KEY, JSON.stringify(m)); } catch { /* ignore */ }
}
